/* eslint-disable max-lines */
import {
    OperationDoc,
    TransportWarning,
    RedPointCountUsingGetParams,
    MenuRedPointVo,
    RecalculateSupplierFreightEnabledVo,
    SetRecalculateSupplierFreightEnabledParam,
    LoginErpSettlementUsingGetParams,
    LoginErpSupplierActionLogUsingGetParams,
    LoginErpFreightRuleUsingGetParams,
    ChangePriceLogUsingGetParams,
    ShortLinkParam,
    FeedbackListUsingGetParams,
    Feedback,
    FeedbackQueryParam,
    ImportVisitLogParam,
    BatchAssignShortLinkVo,
    ShortLinkParamV2,
    QueryFreightTemplateUrlForErpUsingGetParams
} from '@servicesTypings/companyRequest'
import {
    QuerySupplierManageVo,
    SupplierManageVo,
    ExportSupplierUsingGetParams,
    ListContactsOfMySupplierUsingGetParams,
    ContactsOfSupplier,
    ListContactsOfMySupplierEncryptionUsingGet1Params,
    GetExportCompanyResultUsingGetParams,
    ExportResultVo,
    TagParam,
    TagVo,
    SyncSupplierReturnAddressToChannelParam,
    BatchUpdateSupplierTagNamesVo,
    BatchUpdateChannelTagNamesVo,
    UpdateApplyCoopNumParam,
    UpdateVideoParam,
    UpdateFactoryVideoCoverParam,
    GetVideoAndPictureParam,
    CompanyVideoVo,
    SupplierInfo,
    QuerySubAccountListForAgentLoginUsingGetParams,
    CompanyUserManageVo,
    MySupplierVo1,
    QuerySyncRegulatePriceParam,
    SyncRegulatePriceVo,
    SupplierContacts,
    DirectionalInvitationsUsingGetParams,
    InviteVo,
    UpdateFindCooperationWeightsVo,
    SaveSupplierOfflineVo,
    SupplierOfflineVo,
    CoSupplierOffline,
    ListUsingGet21Params,
    LoadUsingGet8Params,
    SupplierDisConfig,
    CompanyIdParam,
    DirectionalInvitationsForSecondaryUsingGetParams,
    UpdateFixedCityParam,
    QueryBaseConfigUsingGetParams,
    QuerySupplySettingUsingGetParams,
    AutoCreditVo,
    ListOfflineSupplierGroupUsingGetParams,
    ErpOfflineSupplierVo,
    BindSupplierParam,
    QueryBaseConfigByCoIdUsingGetParams,
    QuerySupplierDisLevelUsingGet1Params,
    QueryDetailListUsingGetParams,
    CompanyActiveDetailVo,
    UpdateMarkKaVo,
    CancelDisPartnerParam,
    FastDeliverInfoUsingGetParams,
    ExportCompanyDetailUsingGetParams,
    ExportVisitLogUsingGetParams,
    Distributor,
    SelectQualityChannelOriginUsingGetParams,
    CoCompany,
    UpdateFactoryVideoWeightsParam,
    RecommendVo,
    SupportCopyLogisticsTemplateSuppliersUsingGetParams,
    SupplierNameValueVo,
    UpdateBrandWallWeightsParam,
    ViewContactWayVo,
    SupplierStartFreightParam,
    SupplierStartFreightVo,
    BatchSetSalesManParam,
    LoadLatestLogUsingGetParams,
    CompanyLabelLogVo,
    PageListUsingGetParams,
    GetSupplierCapacityUsingGetParams,
    SupplierCardWithMask,
    UpdateSupplierTagNamesParam,
    UpdateChannelTagNamesParam,
    QueryBalanceParam,
    SupplierQueryBalanceVo,
    BatchRevokeApplyParam,
    BatchUrgeSupplierParam,
    FastDeliverInfoUsingGet1Params,
    FastDeliverInfoVo,
    QueryAreaStartFreightV2UsingGet3Params,
    QueryAreaStartFreightV2Result,
    QueryMySupplierHandleDrpAfterSaleUsingGetParams,
    MySupplierSimpleInfoResult,
    OrderQuestionTypeResult,
    ApplyCompanyUserProxyLinkAuthUsingGetParams,
    QueryMyStartFreightUsingGetParams,
    QueryCompanyConfigLogUsingGetParams,
    QueryCompanyConfigLogResult,
    PartnerLookingForSourceResult,
    BatchUpdateOperationalWeightParam,
    FieldShowStateParam,
    FieldShowStateResult,
    QueryCanShowToChannelFieldsStatusUsingGetParams,
    CanShowChannelOtherFieldLabelResult,
    QueryCopySupplyGoodsConditionUsingGet1Params,
    QueryCopySupplyGoodsConditionResult
} from '@servicesTypings/drpRequest'
import {
    BuyerSpuStockQueryVo,
    SpuStock,
    OpSpuQueryVo,
    PostSpuVo,
    QuerySupplierPromoteParam,
    SupplierPromoteOrdinaryItemVo,
    HasMoreSkuVo,
    SupplierForShelvedVo,
    CoIdAndSpuId,
    QuerySupplierStockConfigUsingGetParams,
    StockConfigVo,
    CoIdVo,
    CoIdShelvesNumListVo,
    QueryIsErpLargeSupplierUsingGetParams,
    BatchOperateSpuVo,
    FreshmanSpuSimpleResultVo,
    SpuSaleTrendParam,
    SpuSaleTrendResultVo,
    ChangedPartnerSpuQueryParam,
    ChangedPartnerSpuVo,
    DealWithChangedSpuParam,
    MallGoodsUpdateParam,
    UpdatePlatformData,
    QueryDrpItemCountParam,
    QueryDrpItemCountResult,
    QueryTaskUsingGet1Params,
    RedisProgressInfo,
    CheckIfShowOtherPropUsingGetParams,
    ShowOtherPropResult
} from '@servicesTypings/goodsRequest'
import { OrderTrendVo, SendTrendVo, CrmCusVo } from '@servicesTypings/marketRequest'

import {
    companyRequest,
    goodsRequest,
    openGoodsRequest,
    printerRequest,
    securityRequest,
    drpRequest,
    openDrpRequest,
    marketRequest,
    payRequest,
    goodsBasicRequest
} from '@/utils/request'
import { getCacheService } from '@/utils/requestUtils'

import { MerchantIsOpenParam, MerchantCollectionVo } from '@servicesTypings/payRequest'

import {
    QueryMySupplierPageParam,
    QueryRiskMiddleCompanyResult,
    UpdateOverTimeCompensationParam,
    Void
} from '@servicesTypings/drpRequestV3'

// 导出供应商Excel
/**
 *
 */
/**
 * 导出供应商Excel
 */
export function exportSupplier(params: ExportSupplierUsingGetParams): API.Res<object> {
    return drpRequest.get('/companyStatistics/exportSupplier', { params })
}

/**
 *
 */
/**
 * 查询我的供应商的联系人列表信息
 */
export function listContactsOfMySupplier(params: ListContactsOfMySupplierUsingGetParams): API.Res<ContactsOfSupplier> {
    return drpRequest.get('/partner/channel/listContactsOfMySupplier', { params })
}

/**
 *
 */
/**
 * 查询我的供应商的联系人列表信息，加密
 */
export function listContactsOfMySupplierEncryption(
    params: ListContactsOfMySupplierEncryptionUsingGet1Params
): API.Res<ContactsOfSupplier> {
    return drpRequest.get('/partner/channel/listContactsOfMySupplierEncryption', { params })
}

// 首页数量查询
/**
 *
 */
export function querySupplierFirstPageNum(data) {
    return companyRequest.post('/homePage/querySupplierFirstPageNum', { data })
}

// 首页物流预警数量查询
/**
 *
 */
/**
 * 物流预警信息
 */
export function queryDeliverWarningNum(): API.Res<TransportWarning> {
    return companyRequest.get('/logistics/transport/warning')
}

// 查询导出Excel是否完成
/**
 *
 */
/**
 * 查询导出供应商Excel结果
 */
export function getExportCompanyResult(params: GetExportCompanyResultUsingGetParams): API.Res<ExportResultVo> {
    return drpRequest.get('/companyStatistics/getExportCompanyResult', { params })
}

// 查询供应商列表总数
/**
 *
 */
/**
 * swagger找不到此接口
 */
export function querySupplierManageListTotalCount(params) {
    return companyRequest.get('/op/supplierInfo/querySupplierManageListSize', {
        params
    })
}

// 查询修正的大区列表
/**
 *
 */
export function getModifyAreaList() {
    return drpRequest.get('/companyStatistics/getModifyAreaList')
}

// 更新供应商标签库
/**
 *
 */
/**
 * 更新标签
 */
export function updateSupplierTag(data: List<TagParam>): API.Res<object> {
    return drpRequest.post('/op/tag/updateTagNames', { data })
}

// 查询供应商标签库
/**
 *
 */
/**
 * 查询供应商标签列表
 */
export function querySupplierTag(): API.Res<TagVo[]> {
    return drpRequest.get('/op/tag/getSupplierTagList')
}

// 查询供应商管理标签搜索框下拉列表
/**
 *
 */
/**
 * 查询供应商管理标签搜索框下拉列表
 */
export function getSupplierTagSelectorOptions(): API.Res<string[]> {
    return drpRequest.get('/op/tag/getSupplierTagSelectorOptions')
}

// 查询渠道标签库
/**
 *
 */
/**
 * 查询分销商标签列表
 */
export function queryChannelTag(): API.Res<TagVo[]> {
    return drpRequest.get('/op/tag/getChannelTagList')
}

// 更新同步供应商退货地址给分销商开关
/**
 *
 */
/**
 * 更新同步供应商退货地址给分销商开关
 */
export function updateSyncSupplierReturnAddressToChannel(data: SyncSupplierReturnAddressToChannelParam): API.Res<null> {
    return drpRequest.post('/partner/channel/updateSyncSupplierReturnAddressToChannel', { data })
}

// 批量移除选定的供应商标签
/**
 *
 */
/**
 * 批量删除商家标签
 */
export function batchRemoveSupplierTag(data: BatchUpdateSupplierTagNamesVo): API.Res<object> {
    return drpRequest.post('/op/supplierInfo/batchRemoveSupplierTagNames', { data })
}

// 批量移除选定的渠道标签
/**
 *
 */
/**
 * 批量删除渠道标签
 */
export function batchRemoveChannelTag(data: BatchUpdateChannelTagNamesVo): API.Res<object> {
    return drpRequest.post('/op/channel/batchRemoveChannelTagNames', { data })
}

// 批量添加选定的供应商标签
/**
 *
 */
/**
 * 批量添加商家标签
 */
export function batchAttachSupplierTag(data: BatchUpdateSupplierTagNamesVo): API.Res<object> {
    return drpRequest.post('/op/supplierInfo/batchUpdateSupplierTagNames', { data })
}

// 批量添加选定的渠道标签
/**
 *
 */
/**
 * 批量添加渠道标签
 */
export function batchAttachChannelTag(data: BatchUpdateChannelTagNamesVo): API.Res<object> {
    return drpRequest.post('/op/channel/batchUpdateChannelTagNames', { data })
}

// 更新供应商剩余可申请合作次数
/**
 *
 */
/**
 * 设置申请与分销商合作的次数
 */
export function updateSupplierMaxApplyCount(data: UpdateApplyCoopNumParam): API.Res<object> {
    return drpRequest.post('/op/supplierInfo/updateSupplierMaxApplyCount', { data })
}

// 修改商家视频链接
/**
 *
 */
/**
 * 修改商家视频链接
 */
export function updateCompanyVideoUrl(data: UpdateVideoParam): API.Res<object> {
    return drpRequest.post('/companyCard/updateCompanyVideoUrl', { data })
}

// 修改商家视频封面链接
/**
 *
 */
/**
 * 修改商家视频封面链接
 */
export function updateFactoryVideoCoverUrl(data: UpdateFactoryVideoCoverParam): API.Res<object> {
    return drpRequest.post('/companyCard/updateFactoryVideoCoverUrl', { data })
}

// 获取商家视频
/**
 *
 */
/**
 * 获取商家视频
 */
export function getCompanyVideoUrl(data: GetVideoAndPictureParam): API.Res<CompanyVideoVo[]> {
    return drpRequest.post('/companyCard/getCompanyVideoUrl', { data })
}

// 修改平台-组织对接备注
/**
 *
 */
/**
 * 修改对接备注
 */
export function updateSupplierRemark(data: SupplierInfo): API.Res<string> {
    return drpRequest.post('/op/supplierInfo/updateRemark', { data })
}

// 代理登录前调用获取信息
/**
 *
 */
/**
 * 查询子账户列表
 */
export function querySubCompanyUserListForAgentLogin(
    params: QuerySubAccountListForAgentLoginUsingGetParams
): API.Res<CompanyUserManageVo[]> {
    return drpRequest.get('/subAccount/querySubCompanyUserListForAgentLogin', { params })
}

// 代理登录
/**
 *
 */
export function manageAgentLogin(data) {
    return securityRequest.post('/manage/login/manageAgentLogin', {
        data
    })
}

// 查询我的供应商列表
/**
 *
 */
/**
 * 查询我的供应商
 */
export function queryMySupplierList(data: QueryMySupplierPageParam): API.Res<MySupplierVo1[]> {
    return drpRequest.post('/mySupplier/queryMySupplier', { data })
}

// 查询同步供应商控价开关状态
/**
 *
 */
/**
 * 查询同步供应商控价开关状态
 */
export function querySyncRegulatePrice(data: QuerySyncRegulatePriceParam): API.Res<SyncRegulatePriceVo[]> {
    return drpRequest.post('/partner/channel/querySyncRegulatePrice', { data })
}

// 查询供应商是否存在多个联系人信息
/**
 *
 */
/**
 * 查询供应商是否存在多个联系人信息
 */
export function supplierContacts(data: string[]): API.Res<SupplierContacts[]> {
    return drpRequest.post('/partner/channel/supplierContacts', { data })
}

// 修改供应商的合作状态
/**
 *
 */
export function updateSupplierStatus(data) {
    return drpRequest.post('/mySupplier/updatePartnerStatusByCoId', { data })
}

// 批量合作分销关系
/**
 *
 */
export function betchUpdateSupplierStatus(data) {
    return drpRequest.post('/partner/channel/batchBuildRelationByInvite', { data })
}

// 上传品宣视频
/**
 *
 */
/**
 * 上传品宣视频
 */
export function updateSupplierVideo(data: SupplierInfo): API.Res<string> {
    return drpRequest.post('/op/supplierInfo/updateVideoUrl', { data })
}

// 查询定向邀约分享链接
/**
 *
 */
/**
 * 发起定向邀约
 */
export function queryInviteUrl(params: DirectionalInvitationsUsingGetParams): API.Res<InviteVo> {
    return drpRequest.get('/coDisInvite/directionalInvitations', { params })
}

// 更新供应商权重
/**
 *
 */
/**
 * 更新供应商权重
 */
export function setWeightApi(data: SupplierInfo): API.Res<object> {
    return drpRequest.post('/op/supplierInfo/updateSupplierWeights', { data })
}

// 更新供应商寻合作权重
/**
 *
 */
/**
 * 更新寻合作分销商权重
 */
export function setFindCooperationWeightsApi(data: UpdateFindCooperationWeightsVo): API.Res<object> {
    return drpRequest.post('/op/channel/updateFindCooperationWeights', { data })
}

// 删除线下供应商信息
/**
 *
 */
/**
 * 删除线下供应商信息
 */
export function removeSupplierOffline(data: SaveSupplierOfflineVo): API.Res<SupplierOfflineVo> {
    return drpRequest.post('/supplier/offline/remove', { data })
}

// 保存供应商信息（新增/修改）
/**
 *
 */
/**
 * 保存供应商信息（新增/修改）
 */
export function saveSupplierOffline(data: SaveSupplierOfflineVo): API.Res<CoSupplierOffline> {
    return drpRequest.post('/supplier/offline/saveSupplierOffline', { data })
}

// 获取线下供应商列表
/**
 *
 */
/**
 * 获取线下供应商列表
 */
export function getSupplierListOffline(params: ListUsingGet21Params): API.Res<SupplierOfflineVo[]> {
    return drpRequest.get('/supplier/offline/list', { params })
}

// 获取线下供应商信息
/**
 *
 */
/**
 * 获取线下供应商信息
 */
export function getSupplierInftOffline(params: LoadUsingGet8Params): API.Res<CoSupplierOffline> {
    return drpRequest.get('/supplier/offline/load', { params })
}

// 获取订单推送设置
/**
 *
 */
/**
 * 获取订单拦截配置
 */
export function getOrderInterceptConfig(): API.Res<string> {
    return drpRequest.get('/disConfig/getOrderIntercept')
}

// 保存订单配置
/**
 *
 */
/**
 * 修改订单拦截设置
 */
export function saveOrderInterceptConfig(data: SupplierDisConfig): API.Res<object> {
    return drpRequest.post('/disConfig/orderInterceptConfig', { data })
}

// 保存订单配置
/**
 *
 */
/**
 * 修改供销配置
 */
export function setSupplySetting(data: object): API.Res<null> {
    return drpRequest.post('/supplyConfig/setSupplySetting', { data })
}

export interface SetDrpNolcPushParams {
    /** 当订单匹配不到快递，仍允许分销商推单 */
    drpNolcPush: boolean
}

/** 供应商配置 当订单匹配不到快递，仍允许分销商推单 */
export function setDrpNolcPush(data: SetDrpNolcPushParams): API.Res {
    return drpRequest.post('/supplier/setDrpNolcPush', { data })
}

// 修改备注信息
/**
 *
 */
/**
 * 设置备注
 */
export function setRemarkApi(data: CompanyIdParam): API.Res<object> {
    return drpRequest.post('/myPartner/setRemark', { data })
}

// 修改平台-组织对接备注
/**
 *
 */
/**
 * 修改对接运营信息
 */
export function updateDockingPeopleInfo(data: SupplierInfo): API.Res<string> {
    return drpRequest.post('/op/supplierInfo/updateDockingPeopleInfo', { data })
}

// 修改平台-修改对接BD人员信息
/**
 *
 */
/**
 * 修改对接BD人员信息
 */
export function updateDockingBbInfo(data: SupplierInfo): API.Res<string> {
    return drpRequest.post('/op/supplierInfo/updateDockingBbInfo', { data })
}

// 查询定向邀约分享链接(供应商以渠道身份邀请供应商供货)
/**
 *
 */
/**
 * 发起定向邀约(二级分销)
 */
export function queryInviteUrlSupplier(params: DirectionalInvitationsForSecondaryUsingGetParams): API.Res<InviteVo> {
    return drpRequest.get('/coDisInvite/directionalInvitationsForSecondary', { params })
}

// 更新供销商修正城市
/**
 *
 */
/**
 * 更新供销商修正城市
 */
export function updateSupplierFixedCityApi(data: UpdateFixedCityParam): API.Res<object> {
    return drpRequest.post('/op/supplierInfo/updateSupplierFixedCity', { data })
}

// 查询全部供销商城市
/**
 *
 */
/**
 * 查询全部供销商修正城市
 */
export function queryAllSupplierFixedCity(): API.Res<string[]> {
    return drpRequest.get('/op/supplierInfo/queryAllSupplierFixedCity')
}

// 查询基础配置(通用 传openKey)
/**
 *
 */
/**
 * 查询基础配置（通用，传openKey集合）
 */
export function queryBaseConfig(params: QueryBaseConfigUsingGetParams): API.Res<Record<string, object>> {
    return drpRequest.get('/config/queryBaseConfig', { params })
}

// 查询供应商基础配置
/**
 *
 */
/**
 * 获取供销配置
 */
export function querySupplySetting(params: QuerySupplySettingUsingGetParams): API.Res<Record<string, object>> {
    return drpRequest.get('/supplyConfig/querySupplySetting', { params })
}

// 查询供应商基础配置
/**
 *
 */
/**
 * 查询自动授信配置
 */
export function queryAutoCredit(): API.Res<AutoCreditVo> {
    return drpRequest.get('/supplyConfig/queryAutoCredit')
}

// 根据商品编码查询重复组合装商品列表
/**
 *
 */
/**
 * 根据商品编码查询重复组合装商品列表
 */
export function queryRepeatCombinedGoodListByItemCode(data: string): API.Res<string[]> {
    return goodsRequest.post('/combinedGoods/queryRepeatCombinedGoodListByItemCode', { data })
}

// 设置基础配置（通用，传openKey）
/**
 *
 */
/**
 * 设置基础配置（通用，传json）
 */
export function setBaseConfig(data: object): API.Res<object> {
    return drpRequest.post('/config/setBaseConfig', { data })
}

// 根据md5查询单号
/**
 *
 */
export function queryNoByMd5(params) {
    return printerRequest.get('/open/saleOutOrder/queryParam', {
        params
    })
}

// 查询商家是否开启库存2.0
/**
 *
 */
/**
 * 查询商家是否开启库存2.0
 */
export function queryOpenStockV2(): API.Res<boolean> {
    return drpRequest.get('/config/queryOpenStockV2')
}

// 查询红点是否展示 红点统计
/**
 *
 */
/**
 * 红点统计
 */
export function queryRedPointMenuList(params: RedPointCountUsingGetParams): API.Res<Record<string, MenuRedPointVo>> {
    return companyRequest.get('/redPoint/menu/list', { params })
}

// 联登ERP供销商对账明细
/**
 *
 */
/**
 * 联登ERP供销商对账明细
 */
export function loginErpSettlement(params: LoginErpSettlementUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpSettlement', { params })
}

// 联登ERP供销商日志
/**
 *
 */
/**
 * 联登ERP供销商日志
 */
export function loginErpSupplierActionLog(params: LoginErpSupplierActionLogUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpSupplierActionLog', { params })
}

// 联登ERP供销商运费模板
/**
 *
 */
/**
 * 联登ERP供销商运费模板
 */
export function loginErpFreightRule(params: LoginErpFreightRuleUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpFreightRule', { params })
}

// 跳转ERP改价日志
/**
 *
 */
/**
 * 跳转ERP改价日志
 */
export function changePriceLogApi(params: ChangePriceLogUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/changePriceLog', { params })
}

// 获取绑定供应商弹窗列表
/**
 *
 */
/**
 * 查询线下供应商列表（绑定供应商弹框调用）
 */
export function getListOfflineSupplierGroup(
    params: ListOfflineSupplierGroupUsingGetParams
): API.Res<ErpOfflineSupplierVo[]> {
    return drpRequest.get('/supplier/offline/listOfflineSupplierGroup', { params })
}

// 绑定线下供应商
/**
 *
 */
/**
 * 绑定线下供应商
 */
export function bindOfflineSupplier(data: BindSupplierParam): API.Res<object> {
    return drpRequest.post('/supplier/offline/bindOfflineSupplier', { data })
}

// 根据coid 查询基础配置( 传openKey)
/**
 *
 */
/**
 * 根据coId查询基础配置（通用，传openKey集合）
 */
export function queryBaseConfigByCoId(params: QueryBaseConfigByCoIdUsingGetParams): API.Res<Record<string, object>> {
    return drpRequest.get('/config/queryBaseConfigByCoId', { params })
}

// 根据coid 分销等级
/**
 *
 */
/**
 * 查询指定供应商的分销等级
 */
export function querySupplierDisLevelApi(params: QuerySupplierDisLevelUsingGet1Params): API.Res<number> {
    return drpRequest.get('/myPartner/querySupplierDisLevel', { params })
}

// 跳到分销判断策略
/**
 *
 */
/**
 * 跳转分销判断策略
 */
export function drpRuleApi(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/drpRule')
}

// 跳到通用设定
/**
 *
 */
/**
 * 跳转通用设定
 */
export function distributorSettingApi(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/distributorSetting')
}

/**
 * @description:  供应商活跃详情 (中台-客户跟踪分析)
 * @param {pageSize}
 * @param {pageNum}
 * @param {vagueSearch}   关键字
 * @return:
 */
/**
 * 查询客户明细列表
 */
export function querySupplierCompanyDetail(params: QueryDetailListUsingGetParams): API.Res<CompanyActiveDetailVo[]> {
    return drpRequest.get('/op/companyActiveDetail/queryDetailList', { params })
}

// 跳到通用设定 (中台-客户跟踪分析)
/**
 *
 */
/**
 * 更新ka客户分析列表
 */
export function updateMarkKa(data: UpdateMarkKaVo): API.Res<object> {
    return drpRequest.post('/op/companyActiveDetail/updateMarkKa', { data })
}

// 根据长链接换短链接
/**
 *
 */
/**
 * 根据长链接换短链接
 */
export function assignShortLink(data: ShortLinkParam): API.Res<string> {
    return companyRequest.post('/shortLink/assignShortLink', { data })
}

// 撤回申请
/**
 *
 */
/**
 * 撤回申请
 */
export function revokeApply(data: CancelDisPartnerParam): API.Res<object> {
    return drpRequest.post('/myPartner/revokeApply', { data })
}

// 查询供应商商品库存列表
/**
 *
 */
/**
 * 查询供应商商品库存列表
 */
export function goodsStock(data: BuyerSpuStockQueryVo): API.Res<SpuStock[]> {
    return goodsRequest.post('/buyer/supplier/goods/stock', { data })
}

// 极速代发 未登录 查询分销商信息
/**
 *
 */
/**
 * 未登录用户打开邀请开通极速代发链接，显示加密分销商名称
 */
export function fastDeliverInfoOpen(params: FastDeliverInfoUsingGet1Params): API.Res<FastDeliverInfoVo> {
    return openDrpRequest.get('/open/op/disInvite/fastDeliverInfo', { params })
}

/** 极速代发 获取主营平台和店铺数 */
/**
 * 获取主营平台和店铺数 (转换包含中文无法完全转换)
 */
export function getMainPlatformsAndStoreCountApi(): API.Res<any> {
    return companyRequest.get('/erpShopInfo/getMainPlatformsAndStoreCount')
}

// 极速代发 登录 查询分销商信息
/**
 *
 */
/**
 * 登录用户打开邀请开通极速代发链接，显示分销商相关信息
 */
export function fastDeliverInfo(params: FastDeliverInfoUsingGetParams): API.Res<FastDeliverInfoVo> {
    return drpRequest.get('/coDisInvite/fastDeliverInfo', { params })
}

// 拒绝开通极速代发
/**
 *
 */
/**
 * 拒绝开通极速代发(供应商调用)
 */
export function refuseFastDeliver(data: InviteVo): API.Res<boolean> {
    return drpRequest.post('/myPartner/refuseFastDeliver', { data })
}

// 未合作、合作 的同意开启
/**
 *
 */
export function confirmFastDeliver(data) {
    return drpRequest.post('/myPartner/confirmFastDeliver', { data })
}

// 用户反馈列表
/**
 *
 */
/**
 * feedbackList
 */
export function getUserFeedbackList(params: FeedbackListUsingGetParams): API.Res<Feedback[]> {
    return companyRequest.get('/op/feedbackList', { params })
}

// 用户反馈列表导出
/**
 *
 */
/**
 * 导出用户反馈
 */
export function exportUserFeedback(data: string[]): API.Res<any> {
    return companyRequest.post('/op/exportFeedback', { data })
}

// 用户反馈列表全部导出
/**
 *
 */
/**
 * 导出全部用户反馈
 */
export function exportAllUserFeedback(data: FeedbackQueryParam): API.Res<any> {
    return companyRequest.post('/op/exportFeedbackAll', { data })
}

// 导出客户明细
/**
 *
 */
/**
 * 导出公司详情
 */
export function exportCustomerDetail(params: ExportCompanyDetailUsingGetParams): API.Res<string> {
    return drpRequest.get('/op/companyActiveDetail/exportCompanyDetail', { params })
}

// 导出客户日志
/**
 *
 */
/**
 * 导出拜访日志
 */
export function exportVisitLog(params: ExportVisitLogUsingGetParams): API.Res<string> {
    return drpRequest.get('/op/companyActiveDetail/exportVisitLog', { params })
}

// 导入客户日志
/**
 *
 */
/**
 * swagger找不到此接口
 */
export function importVisitLog(data) {
    return companyRequest.post('/op/visitLog/importVisitLog', {
        data
    })
}

// 导入客户日志 校验重复数据
/**
 *
 */
/**
 * 校验重复数据
 */
export function checkRepeatedData(data: ImportVisitLogParam): API.Res<boolean> {
    return companyRequest.post('/op/visitLog/checkRepeatedData', { data })
}

// 批量获取是否免费版本 (20221010 合同版本优化 以后用这个接口)
/**
 *
 */
/**
 * 批量获取是否Vip版本
 */
export function batchGetWhetherFreeVersion(data: string): API.Res<Record<string, boolean>> {
    return drpRequest.post('/companyContract/batchGetWhetherVipVersion', { data })
}

// 查询我的供应商列表（金额/是否开启极速代发字段）
/**
 *
 */
/**
 * 我的供应商列表(ERP)
 */
export function queryErpList(): API.Res<Distributor[]> {
    return drpRequest.post('/mySupplier/erpList')
}

// 获取分销商来源
/**
 *
 */
/**
 * 优质分销商来源
 */
export function queryQualityOrigin(params: SelectQualityChannelOriginUsingGetParams): API.Res<string> {
    return drpRequest.get('/channel/qualityOrigin', { params })
}

// 查询我的供应商开通在线支付的数量
/**
 *
 */
/**
 * 查询我的供应商开通在线支付的数量
 */
export function queryMySupplierOnlinePayCount(): API.Res<number> {
    return drpRequest.get('/mySupplier/queryMySupplierOnlinePayCount')
}

// coId
// coName
// goodsNum
// id
// onlinePay

// 根据coId集合查询(最多1000个coId)
/**
 *
 */
/**
 * 根据coId集合查询(最多1000个coId)
 */
export function queryCompanyByCoIdList(data: string[]): API.Res<CoCompany[]> {
    return drpRequest.post('/company/queryCompanyByCoIdList', { data })
}

// 根据coId更新商品数量限制
/**
 *
 */
export function upsertGoodsLimitByCoId(data) {
    return goodsBasicRequest.post('/limit/upsertGoodsLimitByCoId', {
        data
    })
}

// 根据coId列表查询商品数量限制列表
/**
 *
 */
export function queryGoodsLimitByCoIdList(data) {
    return goodsBasicRequest.post('/limit/queryGoodsLimitByCoIdList', {
        data
    })
}

// 修改探厂视频权重
/**
 *
 */
/**
 * 修改探厂视频权重
 */
export function updateFactoryVideoWeightsApi(data: UpdateFactoryVideoWeightsParam): API.Res<object> {
    return drpRequest.post('/op/supplierInfo/updateFactoryVideoWeights', { data })
}

// 分销海报，获取公开商品列表
/**
 *
 */
/**
 * 分销海报，获取公开商品列表
 */
export function querySpuList(data: OpSpuQueryVo): API.Res<PostSpuVo[]> {
    return goodsRequest.post('/op/mall/goods/openSpuList', { data })
}

// 查询供应商的推广的商品
/**
 *
 */
/**
 * 查询供应商的推广的商品
 */
export function querySupplierItems(data: QuerySupplierPromoteParam): API.Res<SupplierPromoteOrdinaryItemVo[]> {
    return goodsRequest.post('/goGoodsPromote/querySupplierItems', { data })
}

// 所选sku所在款下是否有更多sku
/**
 *
 */
/**
 * 所选sku所在款下是否有更多sku
 */
export function hasMoreSku(data: HasMoreSkuVo): API.Res<boolean> {
    return goodsRequest.post('/distributor/erp/sku/import/hasMoreSku', { data })
}

// 批量根据长链接换短链接(中台用)
/**
 *
 */
/**
 * 批量根据长链接换短链接(中台用)
 */
export function batchAssignShortLinkForOp(data: ShortLinkParam[]): API.Res<BatchAssignShortLinkVo[]> {
    return companyRequest.post('/shortLink/batchAssignShortLinkForOp', { data })
}

// 修改水滴推荐语
/**
 *
 */
/**
 * 修改水滴推荐语
 */
export function updateRecommend(data: RecommendVo): API.Res<object> {
    return drpRequest.post('/company/updateRecommend', { data })
}

// 获取操作手册
/**
 *
 */
/**
 * 获取操作手册
 */
export function getOperationDoc(data: OperationDoc): API.Res<string> {
    return drpRequest.post('/operationDoc/getOperationDoc', { data })
}

// 查询水滴推荐语
/**
 *
 */
/**
 * 查询水滴推荐语
 */
export function queryRecommend(data: string[]): API.Res<RecommendVo[]> {
    return drpRequest.post('/company/queryRecommend', { data })
}

// 获取合作中的，且支持分销商复制分销运费模板的供应商列表
/**
 *
 */
/**
 * 获取合作中的，且支持分销商复制分销运费模板的供应商列表
 */
export function supportCopySuppliers(
    params: SupportCopyLogisticsTemplateSuppliersUsingGetParams
): API.Res<SupplierNameValueVo[]> {
    return drpRequest.get('/partner/supplier/logisticsTemplate/supportCopySuppliers', { params })
}

// 修改品牌墙权重 只能是有品牌墙商家标签的才能修改
/**
 *
 */
/**
 * 修改品牌墙权重
 */
export function updateBrandWallWeights(data: UpdateBrandWallWeightsParam): API.Res<null> {
    return drpRequest.post('/op/supplierInfo/updateBrandWallWeights', { data })
}

// 批量查询未合作可查看联系方式
/**
 *
 */
/**
 * 批量查询未合作可查看联系方式
 */
export function batchQueryViewContactWay(data: string[]): API.Res<ViewContactWayVo[]> {
    return drpRequest.post('/companyCard/batchQueryViewContactWay', { data })
}

// 查询指定供应商已下架SKU数量
/**
 *
 */
/**
 * 查询指定供应商已下架SKU数量
 */
export function querySupplierForShelved(data: string[]): API.Res<SupplierForShelvedVo[]> {
    return goodsRequest.post('/goChannelPartnerSku/querySupplierForShelved', { data })
}

// 查询供应商启始运费
/**
 *
 */
/**
 * 查询供应商启始运费
 */
export function querySupplierStartFreight(data: SupplierStartFreightParam): API.Res<SupplierStartFreightVo> {
    return drpRequest.post('/supplier/logistics/querySupplierStartFreight', { data })
}

// 查询供应商启始运费 open
/**
 *
 */
/**
 * 查询供应商启始运费
 */
export function querySupplierStartFreightOpen(data: SupplierStartFreightParam): API.Res<SupplierStartFreightVo> {
    return openDrpRequest.post('/open/supplier/logistics/querySupplierStartFreight', { data })
}

// 查询供应商商品库存列表
/**
 *
 */
/**
 * 查询供应商商品库存列表
 */
export function freshmanGoodsStock(data: CoIdAndSpuId[]): API.Res<SpuStock[]> {
    return goodsRequest.post('/freshman/mall/goods/stock', { data })
}

// 查询供应商的库存配置
/**
 *
 */
/**
 * 查询供应商的库存配置
 */
export function querySupplierStockConfig(params: QuerySupplierStockConfigUsingGetParams): API.Res<StockConfigVo> {
    return goodsRequest.get('/goods/stock/querySupplierStockConfig', { params })
}

// 触发ERP分销库存计算
/**
 *
 */
/**
 * 触发ERP分销库存计算
 */
export function calcDrpInventory(data: CoIdVo): API.Res<object> {
    return goodsRequest.post('/buyer/supplier/calcDrpInventory', { data })
}

// 查询分销商已设置的业务员列表
/**
 *
 */
export function getChannelBindSubAccountList() {
    return drpRequest.get('/subAccount/getChannelBindSubAccountList')
}

// 查询分销商已设置的业务员列表
/**
 *
 */
/**
 * 批量设置业务员
 */
export function batchSetSalesMan(data: BatchSetSalesManParam): API.Res<null> {
    return drpRequest.post('/partner/channel/batchSetSalesMan', { data })
}

// 查询最新的日志
/**
 *
 */
/**
 * 查询最新的日志
 */
export function loadLatestLog(params: LoadLatestLogUsingGetParams): API.Res<CompanyLabelLogVo> {
    return drpRequest.get('/op/company/companyLabelLog/loadLatestLog', { params })
}

// 查询最新的日志
/**
 *
 */
/**
 * 分页查询日志
 */
export function pageList(params: PageListUsingGetParams): API.Res<CompanyLabelLogVo[]> {
    return drpRequest.get('/op/company/companyLabelLog/pageList', { params })
}

// 查询商家上星期的铺货数量
/**
 *
 */
/**
 * 查询商家最近7天的铺货数量
 */
export function queryLastWeekCoIdShelvesNum(data: string[]): API.Res<CoIdShelvesNumListVo[]> {
    return goodsRequest.post('/goods/goShelvesBatch/queryLastWeekCoIdShelvesNum', { data })
}

// 获取商家的铺货数量限制
/**
 *
 */
export function queryShelvesLimitByCoIdList(data) {
    return goodsBasicRequest.post('/shelves/limit/queryByCoIdList', {
        data
    })
}

// 修改商家每日铺货数量上限
/**
 *
 */
export function upsertShelvesLimitByCoIdList(data) {
    return goodsBasicRequest.post('/shelves/limit/upsertLimit', {
        data
    })
}

// 查询商家能力
/**
 *
 */
/**
 * 查询商家能力
 */
export function getSupplierCapacityApi(params: GetSupplierCapacityUsingGetParams): API.Res<SupplierCardWithMask> {
    return drpRequest.get('/op/supplierInfo/getSupplierCapacity', { params })
}

// 查询每日铺货上限操作日志
/**
 *
 */
export function queryLimitOperateDetails(params) {
    return goodsBasicRequest.get('/shelves/limit/queryLimitOperateDetails', {
        params
    })
}

// 供应商是否大数据量商家
/**
 *
 */
/**
 * 查询商家是否属于ERP大数据量商家
 */
export function queryIsLargeSupplier(params: QueryIsErpLargeSupplierUsingGetParams): API.Res<boolean> {
    return goodsRequest.get('/buyer/supplier/queryIsErpLargeSupplier', { params })
}

// 批量查询新人专区简略商品信息
/**
 *
 */
/**
 * 查询新人专区商品简略信息
 */
export function queryListSimpleGoods(data: BatchOperateSpuVo): API.Res<FreshmanSpuSimpleResultVo[]> {
    return goodsRequest.post('/open/freshman/goods/querySimpleGoods', { data })
}

// 近30日供应商销量趋势
/**
 *
 */
/**
 * 近30日供应商销量趋势
 */
export function querySupplierSaleTrendApi(data: OrderTrendVo): API.Res<Record<string, SendTrendVo[]>> {
    return marketRequest.post('/open/freshman/goods/querySupplierSaleTrend', { data })
}

// 根据长链接换短链接 （库存不准确）
/**
 *
 */
/**
 * 根据长链接换短链接
 */
export function assignShortLinkV2(data: ShortLinkParamV2): API.Res<string> {
    return companyRequest.post('/shortLink/assignShortLinkV2', { data })
}

// 查询供应商销量趋势图
/**
 *
 */
/**
 * 查询供应商销量趋势图
 */
export function querySupplierSaleTrend(data: SpuSaleTrendParam): API.Res<SpuSaleTrendResultVo[]> {
    return goodsRequest.post('/buyer/supplier/querySupplierSaleTrend', { data })
}

// 查询供应商销量趋势图
/**
 *
 */
/**
 * 查询供应商销量趋势图
 */
export function queryOpenSupplierSaleTrend(data: SpuSaleTrendParam): API.Res<SpuSaleTrendResultVo[]> {
    return openGoodsRequest.post('/open/supplier/goods/querySupplierSaleTrend', { data })
}

/** 修改单个供应商标签 */

/**
 *
 */
/**
 * 修改单个供应商标签
 */
export function updateSupplierTagNames(data: UpdateSupplierTagNamesParam): API.Res<object> {
    return drpRequest.post('/op/supplierInfo/updateSupplierTagNames', { data })
}

/** 更新单个分销商标签 */

/**
 *
 */
/**
 * 更新单个分销商标签
 */
export function updateChannelTagName(data: UpdateChannelTagNamesParam): API.Res<object> {
    return drpRequest.post('/op/channel/updateChannelTagName', { data })
}

/**
 * 批量查询用户在对应分销商的分销资金
 */
/**
 * 批量查询用户在对应分销商的分销资金
 */
export function queryBalanceByChannel(data: QueryBalanceParam): API.Res<SupplierQueryBalanceVo[]> {
    return drpRequest.post('/funds/management/channel/queryBalanceByChannel', { data })
}

/**
 * 根据场景Code查询待办事项
 */
export function queryToDoItemsBySceneCode(params) {
    const drpRequestCache = getCacheService(drpRequest)
    return drpRequestCache.get('/toDoItem/queryToDoItemsBySceneCode', { params })
}

/**
 * 根据页面Code查询待办事项
 */
export function queryToDoItemsByPageCode(params) {
    const drpRequestCache = getCacheService(drpRequest)
    return drpRequestCache.get('/toDoItem/queryToDoItemsByPageCode', { params })
}

/**
 * 寻合作找供应商时批量撤回申请
 */
/**
 * 寻合作找供应商时批量撤回申请
 */
export function batchRevokeApplyByChannel(data: BatchRevokeApplyParam): API.Res<null> {
    return drpRequest.post('/myPartner/batchRevokeApplyByChannel', { data })
}

/**
 * 分销商批量修改催促合作时间
 */
/**
 * 分销商批量修改催促合作时间
 */
export function updateUrgeTimeByChannel(data: BatchUrgeSupplierParam): API.Res<null> {
    return drpRequest.post('/partner/channel/updateUrgeTimeByChannel', { data })
}

/**
 * 分销商批量处理供应商申请合作，包括待审核供应商与供应商邀约
 */
export function batchAcceptSupplyApply(data) {
    return drpRequest.post('/partner/channel/batchAcceptSupplyApply', { data })
}

/**
 * 分销商批量拒绝供应商申请合作，包括待审核供应商与供应商邀约
 */
export function batchRefuseSupplyApply(data) {
    return drpRequest.post('/partner/channel/batchRefuseSupplyApply', { data })
}

/**
 * 查询变更的分销商品
 */
/**
 * 查询变更的分销商品
 */
export function queryChangedPartnerSpu(data: ChangedPartnerSpuQueryParam): API.Res<ChangedPartnerSpuVo[]> {
    return goodsRequest.post('/buyer/partnerSpu/queryChangedPartnerSpu', { data })
}

/**
 * 标记已变更的商品
 */
/**
 * 标记已变更的商品
 */
export function dealWithChangedSpu(data: DealWithChangedSpuParam): API.Res<object> {
    return goodsRequest.post('/goods/dealMessage/dealWithChangedSpu', { data })
}

/**
 * 忽略待办事项
 */
export function ignoreToDoItem(data) {
    return drpRequest.post('/toDoItemIgnore/ignoreToDoItem', { data })
}

/**
 * 更新商品主图
 */
/**
 * 更新商品主图
 */
export function updateMallGoodsMainImage(data: MallGoodsUpdateParam): API.Res<string> {
    return goodsRequest.post('/mall/goods/update/mainImage', { data })
}

/**
 * 根据商品列表查询商品已存在的平台资料
 */
/**
 * 根据商品列表查询商品已存在的平台资料
 */
export function queryPlatformDataExistBySpuList(data: UpdatePlatformData): API.Res<string[]> {
    return goodsRequest.post('/goods/platform/queryPlatformDataExistBySpuList', { data })
}

/**
 * 查询7天内变价+下架商品数量+主图变更商品
 */
export function drpItemCountWithSupplierCoIdUsingPOST(data: QueryDrpItemCountParam): API.Res<QueryDrpItemCountResult> {
    return goodsRequest.post('/buyer/partnerSpu/drpItemCountWithSupplierCoId', { data })
}

/**
 * 查询任务状态
 */
export function queryTaskUsingGET1(params: QueryTaskUsingGet1Params): API.Res<RedisProgressInfo> {
    return goodsRequest.get('/buyer/partnerSpu/queryTask', { params })
}

/**
 * 校验终止合作的是否有分销商品
 */
export function checkCancelHasDrpSpuUsingGET(): API.Res<string> {
    return goodsRequest.get('/buyer/partnerSpu/checkCancelHasDrpSpu')
}

/**
 * 查询区域起步运费V2
 */
export function queryAreaStartFreightV2UsingGET3(
    params: QueryAreaStartFreightV2UsingGet3Params
): API.Res<QueryAreaStartFreightV2Result> {
    return drpRequest.get('/supplier/logistics/queryAreaStartFreightV2', { params })
}

/**
 * 查询ERP供销商运费模板URL
 */
export function queryFreightTemplateUrlForERPUsingGET(
    params: QueryFreightTemplateUrlForErpUsingGetParams
): API.Res<string> {
    return companyRequest.get('/joinLoginErp/queryFreightTemplateUrlForERP', { params })
}

/** 查询供应商列表 */
export function queryMySupplierHandleDrpAfterSale(
    params: QueryMySupplierHandleDrpAfterSaleUsingGetParams
): API.Res<MySupplierSimpleInfoResult[]> {
    return drpRequest.get('/mySupplier/queryMySupplierHandleDrpAfterSale', { params })
}
/**
 * 查询供应商启始运费
 */
export function querySupplierStartFreightV2(data: SupplierStartFreightParam): API.Res<SupplierStartFreightVo> {
    return drpRequest.post('/supplier/logistics/querySupplierStartFreightV2', { data })
}
/**
 * 批量查询商家默认收款能力
 */
export function checkCollectionByCoidsUsingPOST(data: MerchantIsOpenParam): API.Res<MerchantCollectionVo[]> {
    return payRequest.post('/merchant/checkCollectionByCoids', { data })
}
/**
 * 查询所有订单异常类型
 */
export function queryAllOrderQuestionTypesUsingGET(): API.Res<OrderQuestionTypeResult[]> {
    return drpRequest.get('/supplyConfig/queryAllOrderQuestionTypes')
}
/**
 * 查询供应商区域起步运费
 */
export function querySupplierAreaStartFreight(params: QueryTaskUsingGet1Params): API.Res<RedisProgressInfo> {
    return drpRequest.get('/supplier/logistics/querySupplierAreaStartFreight', { params })
}

/**
 * 获取ERP运费模板配置页面URL
 */
export function queryFreightTemplateUrlForERP(params: QueryTaskUsingGet1Params): API.Res<RedisProgressInfo> {
    return companyRequest.get('/joinLoginErp/queryFreightTemplateUrlForERP', { params })
}

/**
 * 申请商家用户代理登录授权链接
 */
export function applyCompanyUserProxyLinkAuthUsingGET(
    params: ApplyCompanyUserProxyLinkAuthUsingGetParams
): API.Res<string> {
    return drpRequest.get('/subAccount/applyCompanyUserProxyLinkAuth', { params })
}
/**
 * 查询当前商家起始运费
 */
export function queryMyStartFreightUsingGET(
    params: QueryMyStartFreightUsingGetParams
): API.Res<SupplierStartFreightVo> {
    return drpRequest.get('/supplier/logistics/queryMyStartFreight', { params })
}

/**
 * 查询商家配置日志
 */
export function queryCompanyConfigLogUsingGET(
    params: QueryCompanyConfigLogUsingGetParams
): API.Res<QueryCompanyConfigLogResult[]> {
    return drpRequest.get('/supplyConfig/queryCompanyConfigLog', { params })
}
/**
 * 查询供应商管理列表
 */
export function querySupplierManageListUsingPOST(data: QuerySupplierManageVo): API.Res<SupplierManageVo[]> {
    return drpRequest.post('/op/supplierInfo/querySupplierManageList', { data })
}

/**
 * 获取重算供销运费开关
 */
export function queryRecalculateSupplierFreightEnabledUsingGET(): API.Res<RecalculateSupplierFreightEnabledVo> {
    return companyRequest.get('/order/config/queryRecalculateSupplierFreightEnabled')
}
/**
 * 设置重算供销运费开关
 */
export function setRecalculateSupplierFreightEnabledUsingPOST(
    data: SetRecalculateSupplierFreightEnabledParam
): API.Res<RecalculateSupplierFreightEnabledVo> {
    return companyRequest.post('/order/config/setRecalculateSupplierFreightEnabled', { data })
}

/**
 * 分销商查询原因
 */
export function queryReasonsByChannelUsingPOST(data: string[]): API.Res<PartnerLookingForSourceResult[]> {
    return drpRequest.post('/partner/lookingForSource/queryReasonsByChannel', { data })
}

/**
 * 更新供应商运营权重
 */
export function updateOperationalWeight(data: SupplierInfo): API.Res<object> {
    return drpRequest.post('/op/supplierInfo/updateOperationalWeight', { data })
}

/**
 * 更新供应商运营权重
 */
export function queryOperationLogForPage(params: SupplierInfo): API.Res<object> {
    return drpRequest.get('/op/supplierOperationLog/queryOperationLogForPage', { params })
}

/**
 * 批量更新供应商运营权重
 */
export function batchUpdateOperationalWeightUsingPOST(data: BatchUpdateOperationalWeightParam): API.Res<null> {
    return drpRequest.post('/op/supplierInfo/batchUpdateOperationalWeight', { data })
}

/**
 * 是否展示其他属性
 */
export function checkIfShowOtherPropUsingGET(params: CheckIfShowOtherPropUsingGetParams): API.Res<ShowOtherPropResult> {
    return goodsRequest.get('/buyer/supplier/checkIfShowOtherProp', { params })
}

/**
 * 更新是否展示给分销商字段信息
 */
export function updateShowToChannelFieldsStatusUsingPOST(data: FieldShowStateParam[]): API.Res<null> {
    return drpRequest.post('/supplyConfig/updateShowToChannelFieldsStatus', { data })
}

/**
 * 查询是否展示给分销商字段信息
 */
export function queryShowToChannelFieldsStatusUsingGET(): API.Res<FieldShowStateResult[]> {
    return drpRequest.get('/supplyConfig/queryShowToChannelFieldsStatus')
}

/**
 * 查询可以展示给分销商的其它字段及对应别名
 */
export function queryCanShowToChannelFieldsStatusUsingGET(
    params: QueryCanShowToChannelFieldsStatusUsingGetParams
): API.Res<CanShowChannelOtherFieldLabelResult[]> {
    return drpRequest.get('/supplyConfig/queryCanShowToChannelFieldsStatus', { params })
}

/**
 * 查询分销商是否符合复制供应商商品条件
 */
export function queryCopySupplyGoodsConditionUsingGET1(
    params: QueryCopySupplyGoodsConditionUsingGet1Params
): API.Res<QueryCopySupplyGoodsConditionResult> {
    return drpRequest.get('/supplyConfig/queryCopySupplyGoodsCondition', { params })
}

/**
 * 供应商库存列表复制商品开放其他属性至10
 */
export function updateOtherPropToTenUsingPOST(): API.Res<object> {
    return goodsRequest.post('/buyer/supplier/updateOtherPropToTen')
}

/**
 * 批量获取crm客户名称
 */
export function queryCrmCusNameByCoIdsUsingPOST(data: string[]): API.Res<CrmCusVo[]> {
    return marketRequest.post('/merchant/investment/queryCrmCusNameByCoIds', { data })
}

/**
 * 按条件导出我的供应商
 */
export function exportMySupplierByCondition(data: QueryMySupplierPageParam): API.Res<string> {
    return drpRequest.post('/mySupplier/exportMySupplierByCondition', { data })
}

/**
 * 查询给分销商开通免支付手续费的供应商
 */
export function queryOpenFreeHandlingFeeSupplierCoIds(data: string[]): API.Res<string[]> {
    return drpRequest.post('/mySupplier/queryOpenFreeHandlingFeeSupplierCoIds', { data })
}

/**
 * 查询商家风险中间商信息
 */
export function queryRiskMiddleCompany(): API.Res<QueryRiskMiddleCompanyResult> {
    return drpRequest.get('/riskMiddleCompany/queryRiskMiddleCompany')
}

/**
 * 更新大店的供应商参与超时赔付开关
 */
export function updateOverTimeCompensation(data: UpdateOverTimeCompensationParam): API.Res<Void> {
    return drpRequest.post('/partnerConfig/updateOverTimeCompensation', { data })
}
